module["exports"] = [
  "hr",
  "com",
  "net",
  "eu",
  "org"
];
